module.exports = __webpack_public_path__ + "static/media/icon-search.966b369b.svg";